import React, { useEffect, useState } from "react"
import {
  Col,
  Card,
  Nav,
  CardBody,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Table,
  Row,
} from "reactstrap"
import classnames from "classnames"

//Simple bar
import SimpleBar from "simplebar-react"

export default function Transactions(props) {
  const [activeTab, setactiveTab] = useState("1")
  const [activeTabVisitors, setactiveTabVisitors] = useState("1")
  const [visitorviews, setvisitorviews] = useState([])
  const [referrals, setreferrals] = useState([])
  const [pages, setpages] = useState([])
  const [countries, setcountries] = useState([])
  const [browser, setbrowser] = useState([])
  const [devices, setdevices] = useState([])

  useEffect(() => {
    if (props.data) {
      setreferrals(props.data.referrers)
      setpages(props.data.pages)
      setcountries(props.data.countries)
      setvisitorviews(props.data.pageviews)
      setbrowser(props.data.browser_names)
      setdevices(props.data.device_types)
    }
  }, [props.data])

  if (!Array.isArray(browser)) {
    return null
  }
  return (
    <React.Fragment>
      <Row>
        <Col xl="6">
          <Card>
            <CardBody>
              <h4 className="card-title mb-4">Page Views</h4>

              <Nav pills className="bg-light rounded" role="tablist">
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === "1" })}
                    onClick={() => {
                      setactiveTab("1")
                    }}
                  >
                    Referrals
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === "2" })}
                    onClick={() => {
                      setactiveTab("2")
                    }}
                  >
                    Pages
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent activeTab={activeTab} className="mt-4">
                <TabPane tabId="1">
                  <SimpleBar style={{ maxHeight: "330px" }}>
                    <div className="table-responsive">
                      <Table className="table align-middle table-nowrap">
                        <tbody>
                          {(referrals || []).map((item, index) => (
                            <tr key={index}>
                              <td style={{ width: "50px" }}>
                                <div className={`font-size-22 text-red`}>
                                  <i className={`bx bx-down-arrow-circle`} />
                                </div>
                              </td>

                              <td>
                                <div>
                                  <h5 className="font-size-14 mb-1">
                                    {item.value}
                                  </h5>
                                </div>
                              </td>

                              <td>
                                <div className="text-end">
                                  <h5 className="font-size-14 mb-0">
                                    {item.pageviews}
                                  </h5>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  </SimpleBar>
                </TabPane>
                <TabPane tabId="2">
                  <SimpleBar style={{ maxHeight: "330px" }}>
                    <div className="table-responsive">
                      <Table className="table align-middle table-nowrap">
                        <tbody>
                          {(pages || []).map((item, index) => (
                            <tr key={index}>
                              <td style={{ width: "50px" }}>
                                <div className={`font-size-22 text-primary}`}>
                                  <i className={`bx bx-down-arrow-circle`} />
                                </div>
                              </td>
                              <td>
                                <div>
                                  <h5 className="font-size-14 mb-1">
                                    {item.value}
                                  </h5>
                                </div>
                              </td>
                              <td>
                                <div className="text-end">
                                  <h5 className="font-size-14 mb-0">
                                    {item.pageviews}
                                  </h5>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  </SimpleBar>
                </TabPane>
              </TabContent>
            </CardBody>
          </Card>
        </Col>
        <Col xl="6">
          <Card>
            <CardBody>
              <h4 className="card-title mb-4">Top Page Views</h4>

              <Nav pills className="bg-light rounded" role="tablist">
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: activeTabVisitors === "1",
                    })}
                    onClick={() => {
                      setactiveTabVisitors("1")
                    }}
                  >
                    Devices
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: activeTabVisitors === "2",
                    })}
                    onClick={() => {
                      setactiveTabVisitors("2")
                    }}
                  >
                    Browsers
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: activeTabVisitors === "3",
                    })}
                    onClick={() => {
                      setactiveTabVisitors("3")
                    }}
                  >
                    Countries
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent activeTab={activeTabVisitors} className="mt-4">
                <TabPane tabId="1">
                  <SimpleBar style={{ maxHeight: "330px" }}>
                    <div className="table-responsive">
                      <Table className="table align-middle table-nowrap">
                        <tbody>
                          {
                            <div>
                              <ul className="list-group list-group-flush">
                                {(devices || []).map((item, index) => {
                                  const perstage =
                                    (item.pageviews / visitorviews) * 100

                                  if (perstage < 0.01) {
                                    return null
                                  }

                                  let deviceImg
                                  try {
                                    deviceImg =
                                      require(`../../../assets/images/devices/${item.value}.svg`).default
                                  } catch (error) {
                                    deviceImg =
                                      require(`../../../assets/images/browser/Other.svg`).default
                                  }
                                  return (
                                    <li className="list-group-item" key={index}>
                                      <Row>
                                        <Col>
                                          <div>
                                            <img
                                              src={deviceImg}
                                              alt={`Devices of ${item.value}`}
                                              style={{
                                                width: "40px",
                                                height: "40px",
                                                borderRadius: "20%",
                                              }}
                                            />
                                          </div>
                                        </Col>
                                        <Col lg={11}>
                                          <div className="py-2">
                                            <h5 className="font-size-14">
                                              {item.value}
                                              <span className="float-end">
                                                {perstage.toFixed(2)}%
                                              </span>
                                            </h5>
                                            <div className="progress animated-progress progress-sm">
                                              <div
                                                className="progress-bar bg-red"
                                                role="progressbar"
                                                style={{
                                                  width: `${perstage}%`,
                                                }}
                                                aria-valuenow={perstage}
                                                aria-valuemin="0"
                                                aria-valuemax="100"
                                              ></div>
                                            </div>
                                          </div>
                                        </Col>
                                      </Row>
                                    </li>
                                  )
                                })}
                              </ul>
                            </div>
                          }
                        </tbody>
                      </Table>
                    </div>
                  </SimpleBar>
                </TabPane>
                <TabPane tabId="2">
                  <SimpleBar style={{ maxHeight: "330px" }}>
                    <div className="table-responsive">
                      <Table className="table align-middle table-nowrap">
                        <tbody>
                          {
                            <div>
                              <ul className="list-group list-group-flush">
                                {browser.map((item, index) => {
                                  const perstage =
                                    (item.pageviews / visitorviews) * 100 // Calculate the percentage

                                  if (perstage < 0.01) {
                                    return null // Skip rendering this item if percentage is 0 or less
                                  }

                                  let browserImg
                                  try {
                                    browserImg =
                                      require(`../../../assets/images/browser/${item.value}.svg`).default
                                  } catch (error) {
                                    browserImg =
                                      require(`../../../assets/images/browser/Other.svg`).default
                                  }

                                  return (
                                    <li className="list-group-item" key={index}>
                                      <Row>
                                        <Col>
                                          <img
                                            src={browserImg}
                                            alt={`browser of ${item.value}`}
                                            width="100%"
                                            className="mt-3"
                                            style={{ borderRadius: "20%" }}
                                          />
                                        </Col>
                                        <Col lg={11}>
                                          <div className="py-2">
                                            <h5 className="font-size-14">
                                              {item.value}
                                              <span className="float-end">
                                                {perstage.toFixed(2)}%
                                              </span>
                                            </h5>
                                            <div className="progress animated-progress progress-sm">
                                              <div
                                                className="progress-bar bg-red"
                                                role="progressbar"
                                                style={{
                                                  width: `${perstage}%`,
                                                }}
                                                aria-valuenow={perstage}
                                                aria-valuemin="0"
                                                aria-valuemax="100"
                                              ></div>
                                            </div>
                                          </div>
                                        </Col>
                                      </Row>
                                    </li>
                                  )
                                })}
                              </ul>
                            </div>
                          }
                        </tbody>
                      </Table>
                    </div>
                  </SimpleBar>
                </TabPane>
                <TabPane tabId="3">
                  <SimpleBar style={{ maxHeight: "330px" }}>
                    <div className="table-responsive">
                      <Table className="table align-middle table-nowrap">
                        <tbody>
                          {
                            <div>
                              <ul className="list-group list-group-flush">
                                {(countries || []).map((item, index) => {
                                  const perstage =
                                    (item.pageviews / visitorviews) * 100 // Calculation of percentage

                                  const flag =
                                    require(`../../../assets/images/country/${item.value}.svg`).default
                                  let flagImg
                                  try {
                                    flagImg =
                                      require(`../../../assets/images/country/${item.value}.svg`).default
                                  } catch (error) {
                                    flagImg =
                                      require(`../../../assets/images/browser/Other.svg`).default
                                  }
                                  if (perstage < 0.01) {
                                    return null
                                  }

                                  return (
                                    <li className="list-group-item" key={index}>
                                      <Row>
                                        <Col>
                                          <img
                                            src={flagImg}
                                            alt={`Flag of ${item.value}`}
                                            width="100%"
                                            className="mt-3"
                                            style={{ borderRadius: "20%" }}
                                          />
                                        </Col>
                                        <Col lg={11}>
                                          <div className="py-2">
                                            <h5 className="font-size-15">
                                              {item.value}
                                              <span className="float-end">
                                                {perstage.toFixed(2)}%
                                              </span>
                                            </h5>
                                            <div className="progress animated-progress progress-sm">
                                              <div
                                                className={`progress-bar bg-red`}
                                                role="progressbar"
                                                style={{
                                                  width: `${perstage}%`,
                                                }}
                                                aria-valuenow={perstage}
                                                aria-valuemin="0"
                                                aria-valuemax="100"
                                              ></div>
                                            </div>
                                          </div>
                                        </Col>
                                      </Row>
                                    </li>
                                  )
                                })}
                              </ul>
                            </div>
                          }
                        </tbody>
                      </Table>
                    </div>
                  </SimpleBar>
                </TabPane>
              </TabContent>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}
